import { type MemoryState, isMemoryFull } from '@/lib/memory';
import { cn } from '@/lib/utils';

interface Props {
  state: MemoryState;
  /** 'pill': short and thin, beside the composer. 'sheet': full width. */
  size?: 'pill' | 'sheet';
}

/**
 * One segment per question the chat can remember, filled up to how many it
 * remembers now. Pink while there is room, amber when full. Decorative: the
 * words next to it carry the meaning.
 */
export default function MemoryBar({ state, size = 'pill' }: Props) {
  const full = isMemoryFull(state);
  const on = full ? 'var(--sig-warn-icon)' : 'hsl(var(--primary))';
  return (
    <span
      aria-hidden="true"
      className={cn('flex', size === 'pill' ? 'gap-[2px]' : 'gap-[4px] w-full')}
    >
      {Array.from({ length: state.max }, (_, i) => (
        <span
          key={i}
          className={cn(
            'rounded-full',
            size === 'pill' ? 'h-[8px] w-[3px]' : 'h-[6px] flex-1'
          )}
          style={{
            background: i < state.remembered ? on : 'var(--sig-border-strong)'
          }}
        />
      ))}
    </span>
  );
}
